import Vue from 'vue';
import Router from 'vue-router';
import ErrorScreen from './views/ErrorScreen'
import FormEditScreen from './views/FormEditScreen'
import index from './views/IndexScreen'
import signup from './views/signup'
import signin from './views/signin'
import indexmentorprofile from './views/indexmentorprofile'
import detailprofile from './views/detailmentorprofile'
import userprofile from './views/userprofile'
import signupsuccess from './views/signupsuccess'
import signupprofile from './views/signup-profile'
import forgetpassemail from './views/forgetpassemail'
import bookingmentor from './views/bookingmentor'
import InvestList from './views/InvestList'
import InvestCompanyDetail from './views/InvestCompanyDetail'
import EditProfile from './views/EditProfile'
import Authorized from './views/SignInAuth'
import checktoken from '@/views/checktoken'
import termsOfUse from '@/views/TermsOfUse'

Vue.use(Router);
import store from './store';
const ifNotLogin = (to, from, next) => {
  if (typeof store.state.islogin === 'undefined' || store.state.islogin === null || store.state.islogin === '') {
    next('/signin')
  }else {
    next()
  }
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '*', component: ErrorScreen },
    {
      path: '/index',
      redirect: '/form/edit',
    },
    {
      path: '/booking/mentor',
      name: 'bookingmentor',
      beforeEnter:ifNotLogin,
      component: bookingmentor,
    },
    {
      path: '/forget/:token',
      name: 'forgotpassemail',
      component: forgetpassemail,
    },
    {
      path: '/signup/company',
      name: 'signupprofile',
      component: signupprofile,
    },
    {
      path: '/signup/company/:type',
      name: 'signupprofile',
      component: signupprofile,
    },
    {
      path: '/',
      name: 'index',
      component: index,
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup
    },
    {
      path: '/signup/:type',
      name: 'signup',
      component: signup
    },
    {
      path: '/signupsuccess',
      name: 'signupsuccess',
      beforeEnter:ifNotLogin,
      component: signupsuccess
    },
    {
      path: '/signin',
      name: 'signin',
      component: signin
    },
    {
      path: '/terms',
      name: 'termsOfUse',
      component: termsOfUse
    },
    { // loginsuccessuser
      path: '/user/profile',
      name: 'userprofile',
      beforeEnter:ifNotLogin,
      component: userprofile
    },
    {
      path: '/profile',
      name: 'indexmentorprofile',
      component: indexmentorprofile
    },
    {
      path: '/detail/profile',
      name: 'detailprofile',
      component: detailprofile
    },
    {
      path: '/form/edit',
      name: 'formEditScreen',
      beforeEnter:ifNotLogin,
      component: FormEditScreen,
    },{
      path: '/invest-list',
      name: 'investList',
      beforeEnter:ifNotLogin,
      component: InvestList,
    },
    {
      path: '/invest/company',
      name: 'investCompany',
      beforeEnter:ifNotLogin,
      component: InvestCompanyDetail, 
    },
    {
      path: '/edit-profile',
      name: 'editProfile',
      beforeEnter:ifNotLogin,
      component: EditProfile,
    },{
      path: '/authorized',
      name: 'authorized',
      component: Authorized,
    },
    {
      path: '/token/:tokenmentor',
      name: 'checktoken',
      component: checktoken
    }
  ],
});